import { render, staticRenderFns } from "./studioSupport.vue?vue&type=template&id=683e6cd2&"
import script from "./studioSupport.vue?vue&type=script&lang=js&"
export * from "./studioSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports